<template>
  <div :class="{'container-dark': theme_dark}">
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">我的徒弟</div>
      <div class="nav-right">
        <span class="nav-lable"></span>
        <img src="../../assets/img/返回箭头.png" class="nav-img none" />
      </div>
    </div>

    <div class="txt-tip">
      <div class="tip">
         魅力值达到30万即可收徒，收徒可以获取徒弟礼物收益的10%~20%不等，
        具体收徒方式为找到徒弟，通过聊天沟通的方式确定师徒意向，可在聊天页面，让徒弟直接申请师徒关系即可，
        魅力值达到30万可收10名徒弟，魅力值从30万每增加10万可多收1名徒弟。
      </div>
    </div>

    <div class="add-block" v-if="data.length<=0">
      <div class="not-have ub ub-pc ub-ac">你当前还没有徒弟~</div>
    </div>

    <li class="pupil-block" v-for="(item, index) in data" :key="index">
      <div class="pupil ub ub-pc">
        <img :src="item.photo" class="photo" @click="goto_chat(item.uid)"/>
       
        <div>
          <div class="sp1 ub ub-pc">
            <span>{{item.nick.length > 6 ?item.nick.substr(0,4)+"…":item.nick}}</span>
            <div class="ub ub-pc" :class="item.sex=='女生'? 'sex' : 'sex2'">
              (
              <img v-if="item.sex=='女生'" src="../../assets/img/女.png" class="sex-img" />
              <img v-if="item.sex=='男生'" src="../../assets/img/男.png" class="sex-img" />
              <span :class="item.sex=='女生'? 'sex' : 'sex2'">{{item.sex}}</span>
              )
            </div>
          </div>
          <span class="sp2">总积分:<label class="total-score">{{item.s_total}}</label></span>
        </div>

        <div class="ub ub-ver  ub-f1">
          <div class="ub ub-pc ub-ac2">
            <span class="day">今日:<label class="score">{{item.s_today}}</label></span>
            <span class="btn2 ub ub-pc ub-ac" @click="receive_no(item.s_today)">待领取</span>
          </div>
          <div class="ub ub-pc ub-ac2" style="margin-top: 1em">
            <span class="day">昨日:<label class="score">{{item.s_yest}}</label></span>
            <span class="btn ub ub-pc ub-ac" @click="receive(item.uid,item.s_yest)">领取</span>
          </div>
        </div>

      </div>
    </li>

    <div class="ub ub-pc ub-ac" @click="goto_s_pupil()">
      <div class="ub ub-ac ub-pc add-pupil" >
        <span class="txt">收徒</span>
      </div>
    </div>

  </div>
</template>

<script>
import * as tool from "../../api/common";
import { mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      data: [],
       user_info: {
        score_total:0
      },
      theme_dark: false
    };
  },
  mounted() {
    //切换深色模式
    this.theme_dark = tool.is_theme_dark(this);
    this.init_page();
  },
  methods: {
    ...mapMutations(["get", "post"]), //引入方法
    ...mapActions(["act_get_userinfo", "act_reload_userinfo"]), //引入方法
    back() {
      this.$router.go(-1); //返回上一层
    },
    goto_s_pupil() {
      console.log(this.user_info.score_total);
      if(this.user_info.score_total<300000){
        this.$toast.center("魅力值太低，不符合收徒标准");
        return false;
      }

      this.$router.push({ name: "s_pupil" });
    },
     goto_chat(uid) {
      this.$router.push({ name: "chart", params: { uid: uid } });
    },
    init_page(){
       var self = this;
      var uid = self.$store.state.uid;
      self.act_get_userinfo({
        uid: uid,
        success: function (u) {
          //console.log(JSON.stringify(u));
          self.user_info = u;
          self.score_left = u.score_left;
        },
      });

       var uid = this.$store.state.uid;
       var self = this;
       self.get({
        url: "/App/GetApprenticeList/?uid=" + uid,
        success: function (data) {
          //console.log(JSON.stringify(data));
          self.data=data;
          for(var i=0; i<data.length; i++){
            data[i].photo=self.$store.state.url + "/photo/" +data[i].photo;
          }
        },
      });
    },
    receive(uid_a,score){
       var uid = this.$store.state.uid;
       var self=this;
       self.get({
        url: "/App/GetApprentice_Score/?uid=" + uid+"&uid_a="+uid_a+"&score="+score,
        success: function (data) {
          //console.log(JSON.stringify(data));
          if(data.state=="1"){
             self.$toast.center(data.msg);
          }else{
            self.$toast.center(data.msg);
           
          }
         
        },
      });
    },
    receive_no(score){
      if(score>0){
         this.$toast.center("明日记得来领取");
      }else{
         this.$toast.center("徒弟又在偷懒了，赶快去指导一下~");
      }
     
    }
  },
};
</script>

<style lang="scss" scoped>
.txt-tip {
  padding: 0 0.5rem;
  .tip {
    background-color: #fff;
    font-size: 0.9rem;
    border: 1px solid #dcdcdc;
    border-radius: 0.3rem;
    margin-top: 0.5rem;
    padding: 0.3rem 0.4rem;
    color: #555;
    line-height: 1.6rem;
  }
}

.add-block {
  padding: 0.5rem;
  .not-have{
    border: 1px dashed #dfdfdf;
    border-radius: 0.3rem;
    padding: 0.5rem 0;
    background-color: #fff;
    color:#dcdcdc;
    height: 5rem;
  }
}

.pupil-block {
  padding: 0.5rem 0.5rem 0 0.5rem;
  font-size: 0.85rem;
  .pupil {
    border: 1px solid #dcdcdc;
    border-radius: 0.3rem;
    padding: 1.2rem 0.3rem;
    background-color: #fff;
    .photo {
      width: 4.3rem;
      border-radius: 50%;
      margin-right: 0.5rem;
    }
    .sp1 {
      width: 9rem;
      .sex-img {
        width: 1.25rem;
      }
      .sex {
        color: #ff3ec9;
      }
      .sex2 {
        color: #37b8d5;
      }
    }
    .sp2 {
      display: inline-block;
      margin-top: 0.7rem;
      width: 9rem;
      color: #888;
      .total-score {
        color: #444;
        font-weight: bold;
        font-size: 1.2rem;
      }
    }
    .day {
      margin: 0 0.5rem;
      color: #888;
    }
    .btn2 {
      width: 4.5rem;
      border: 1px solid #888;
      padding: 0.4rem 0;
      border-radius: 0.3rem;
      color: #888;
      font-size: 0.85rem;
    }
    .btn {
      width: 4.5rem;
      border: 1px solid #e92162;
      padding: 0.4rem 0;
      border-radius: 0.3rem;
      color: #e92162;
      font-size: 0.85rem;
    }
    .score {
      color: #e92162;
      font-weight: bold;
      font-size: 1.2rem;
    }
  }
}

.add-pupil {
  margin: 1rem 0;
  padding: 0.5rem 8rem;
  border-radius: 2rem;
  background: linear-gradient( 90deg, #8A61FF 13%, #FE9CC0 91%);
  span {
    font-size: 0.9rem;
    font-weight: bold;
    color: #FFFFFF;
  }
  .txt {
    font-size: 1rem;
  }
}

.container-dark {
  min-height: 100vh;
  background-color: #2F2E33;
  .txt-tip {
    background-color: #2F2E33;
    .tip {
      color: #888;
      background-color: #2c2b30;
      border: 1px solid #888;
    }
  }
  .pupil-block {
    .pupil {
      background-color: #2F2E33;
      border: 1px solid #404040;
      .sp1 {
        color: #FDFDFD;
      }
      .la {
          color: #FDFDFD;
      }
      .total-score {
        color: #888;
      }
    }
  }
}
</style>